require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./about-me-page-fifteen.json") })
        }
      }, "path---about-me-page-fifteen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---about-me-page-fifteen!./.cache/json/about-me-page-fifteen.json
// module id = 499
// module chunks = 231608221292675